import React, { useEffect, useState } from 'react'
import StartBom from './CreateBom/StartBom';
import FindBom from './CreateBom/FindBom';
import BomList from './CreateBom/BomList';
import ProjectList from './CreateBom/ProjectList'
import { DndProvider } from "react-dnd";
import { HTML5Backend } from 'react-dnd-html5-backend';
import Bom from "@system/config/bom";
import System from 'src/helper/system';
import { useBOMStore } from 'src/hooks/bom';
import liveAuth from 'src/helper/liveAuth';
import GuestBomList from './CreateBom/GuestBomList';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import AdminConfig from "@system/config/admin";
import AxiosIndicatorRunTimeLoader from 'src/component/Global/AxiosIndicatorRunTimeLoader';
import ShowAlert from 'src/component/Global/ShowAlert';

export function BOM() {
    const [{ your_bom_listing }, { }, { create_blank_bom }] = useBOMStore();
    const [__check] = useAxiosIndicatorCheck();

    const openWarningPopup = () => {
        System.popup('BomWarningPopUp', { warningCallBack: warningCallBack });
    };
    const warningCallBack = async () => {
        const newBom = await create_blank_bom();
        if (newBom?.data) {
            window.location.href = Bom.getBomDetailByIdRouteURL(
                newBom.data,
                {
                    go: System.getParams().go
                }
            )
        }
    }

    const [showUI, setShowUI] = useState(false)
    useEffect(() => {
        async function fetchHere() {
            if (__check(['BOM_PROJECT_API_CALL_GUEST']).status) {
                setShowUI(true)
            }
        }
        fetchHere()
    }, [__check(['BOM_PROJECT_API_CALL_GUEST']).status]);
    return (
        <>
            <div className="logged-screen">
                <div className="">
                    <div id="main" className="">
                        <div className={liveAuth.check() ? "bom-page" : "bom-page bom-guestuser"}>
                            <div className={liveAuth.check() ? "container" : "container-fluid maxw100"}>
                                <div
                                    className="bom-page-head header-container d-flex align-items-center justify-content-between">
                                    <div className={liveAuth.check() ? "page-title font-oswald font-light font-30" : "font-apecru font-24"}>{liveAuth.check() ? "BOMs":"Create a BOM"}</div>
                                </div>
                                <div className="pcn-line-divider" />

                                <div className='bom-guestuser-container'>

                                    <StartBom />
                                    {!liveAuth.check() &&
                                        <div className='mt-3'>
                                            Don't have a file? <a onClick={() => Object.keys(your_bom_listing).length ? openWarningPopup() : warningCallBack()} className="text-blue2 ms-1">
                                                <strong> Start a new BOM</strong>
                                            </a>
                                        </div>
                                    }
                                    {liveAuth.check() &&
                                        <FindBom />
                                    }
                                    <div className='bom-alert'>
                                        <ShowAlert onlyShowMessage={['deleteBom','deleteBomProject']}/>
                                    </div>
                                    <DndProvider backend={HTML5Backend}>
                                        {liveAuth.check() ?
                                            <BomList bom_listing={your_bom_listing} />
                                            :
                                            <>
                                                {showUI &&
                                                    <>
                                                        {__check(['BOM_PROJECT_API_CALL', 'BOM_PROJECT_API_CALL_GUEST']).status ? (
                                                            <AxiosIndicatorRunTimeLoader />
                                                        ) : (Object.keys(your_bom_listing).length > 0) ? (
                                                            <GuestBomList bom_listing={your_bom_listing} />
                                                        ) : (
                                                            <div className={liveAuth.check() ? "d-none" : "bom-bill-of-material d-block"}>
                                                                <div className='guest-bom-banner-text'>
                                                                    <div className='font-apecru font-30'>Bill of Materials</div>
                                                                    <p className='font-arial font-13 mb-3'>Our free Bill of Materials tool is loaded with features to help you create, manage, customize, and purchase your BOMs. It's our way of doing our part - so you can find yours.</p>
                                                                    <div className='d-flex align-items-center'>
                                                                        <button className="bs5 btn btn-primary btn-sm w100" onClick={() => window.location.href = System.getLoginPageUrl()}>Sign In</button>
                                                                        <button className="bs5 btn btn-secondary btn-sm w100 ms-2" onClick={() => window.location.href = AdminConfig.getRegistrationURL()}> Register</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                        }
                                                    </>
                                                }

                                            </>
                                        }

                                        <ProjectList />

                                    </DndProvider>
                                    {liveAuth.check() &&
                                        <div className="m-t-10 m-b-20 font-13">Avnet reserves the right to remove a BOM after 180
                                            days of non-use
                                        </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}
